import { SeoPageLayout } from "@/components/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoSection";
import { SeoStyledList } from "@/components/seo/SeoStyledList";
import { SeoFeatureGrid } from "@/components/seo/SeoFeatureGrid";
import { SeoHighlightBox } from "@/components/seo/SeoHighlightBox";
import { Building2, MapPin, Star, Home, Landmark } from "lucide-react";

const KomikWroclaw = () => (
  <SeoPageLayout title="Komik i stand-up" titleAccent="Wrocław">
    <SeoSection title="Występy komediowe we Wrocławiu">
      <p>Wrocław - miasto stu mostów, ale też miasto dynamicznie rozwijającej się sceny eventowej i kulturalnej. Jako firma z siedzibą we Wrocławiu, doskonale znamy lokalny rynek i oferujemy profesjonalne występy komediowe na terenie całego Dolnego Śląska.</p>
    </SeoSection>

    <SeoSection title="Wrocław - nasze miasto, nasza scena">
      <p>Wrocław to nasza baza operacyjna, co oznacza, że na terenie miasta i okolic możemy zaoferować najkorzystniejsze warunki współpracy. Znamy najlepsze lokalizacje eventowe, mamy kontakty z lokalnymi dostawcami usług i jesteśmy w stanie szybko zareagować na pilne zapytania.</p>
      <SeoHighlightBox icon={Home}>
        Wrocław to nasz dom - na terenie miasta oferujemy najkrótszy czas reakcji i najkorzystniejsze warunki współpracy.
      </SeoHighlightBox>
    </SeoSection>

    <SeoSection title="Gdzie we Wrocławiu występujemy?">
      <SeoFeatureGrid features={[
        { icon: Landmark, title: "Hala Stulecia", description: "I okoliczne obiekty konferencyjne UNESCO" },
        { icon: Building2, title: "Hotele premium", description: "DoubleTree by Hilton, Sofitel, The Bridge" },
        { icon: MapPin, title: "Centrum i Nadodrze", description: "Restauracje i sale bankietowe w modnych dzielnicach" },
        { icon: Star, title: "Przestrzenie eventowe", description: "Concordia Design i unikalne lokalizacje plenerowe" },
      ]} />
    </SeoSection>

    <SeoSection title="Wrocławska scena stand-upowa">
      <p>Wrocław ma jedną z najbardziej aktywnych scen stand-upowych w Polsce. Regularne open micki, kluby komediowe i festiwale przyciągają zarówno początkujących, jak i doświadczonych komików. Nasi artyści są częścią tej społeczności, co gwarantuje najwyższą jakość i aktualność materiału.</p>
    </SeoSection>
  </SeoPageLayout>
);

export default KomikWroclaw;
